import CopyButton from './CopyButton.jsx';
import { tagColor } from '../utils/tagColor.js';

const COLOR = {
  blue:    { border: 'border-slate-200', strip: 'bg-indigo-500',  tag: 'bg-indigo-50 text-indigo-700 border-indigo-100',     title: 'text-indigo-700'  },
  teal:    { border: 'border-slate-200', strip: 'bg-teal-500',    tag: 'bg-teal-50 text-teal-700 border-teal-100',           title: 'text-teal-700'    },
  green:   { border: 'border-slate-200', strip: 'bg-emerald-500', tag: 'bg-emerald-50 text-emerald-700 border-emerald-100',   title: 'text-emerald-700' },
  yellow:  { border: 'border-slate-200', strip: 'bg-amber-400',   tag: 'bg-amber-50 text-amber-700 border-amber-100',         title: 'text-amber-700'   },
  red:     { border: 'border-slate-200', strip: 'bg-red-500',     tag: 'bg-red-50 text-red-700 border-red-100',               title: 'text-red-700'     },
  pink:    { border: 'border-slate-200', strip: 'bg-pink-500',    tag: 'bg-pink-50 text-pink-700 border-pink-100',             title: 'text-pink-700'    },
  purple:  { border: 'border-slate-200', strip: 'bg-violet-500',  tag: 'bg-violet-50 text-violet-700 border-violet-100',       title: 'text-violet-700'  },
  orange:  { border: 'border-slate-200', strip: 'bg-orange-500',  tag: 'bg-orange-50 text-orange-700 border-orange-100',       title: 'text-orange-700'  },
  cyan:    { border: 'border-slate-200', strip: 'bg-sky-500',     tag: 'bg-sky-50 text-sky-700 border-sky-100',               title: 'text-sky-700'     },
  lime:    { border: 'border-slate-200', strip: 'bg-lime-500',    tag: 'bg-lime-50 text-lime-700 border-lime-100',             title: 'text-lime-700'    },
  rose:    { border: 'border-slate-200', strip: 'bg-rose-500',    tag: 'bg-rose-50 text-rose-700 border-rose-100',             title: 'text-rose-700'    },
  fuchsia: { border: 'border-slate-200', strip: 'bg-fuchsia-500', tag: 'bg-fuchsia-50 text-fuchsia-700 border-fuchsia-100',   title: 'text-fuchsia-700' },
};

export default function PromptCard({ prompt }) {
  const c = COLOR[tagColor(prompt.tag) || prompt.color] || COLOR.blue;

  return (
    <div className={`rounded-2xl border ${c.border} bg-white shadow-card hover:shadow-card-hover transition-shadow overflow-hidden flex flex-col`}>
      {/* colored top strip */}
      <div className={`h-1 ${c.strip}`} />

      <div className="p-4 flex flex-col gap-3">
        <div className="flex items-start justify-between gap-2">
          <div className="flex-1 min-w-0">
            <h3 className={`font-bold text-base ${c.title} leading-snug`}>{prompt.name}</h3>
            {prompt.tag && (
              <span className={`inline-block mt-1.5 text-xs px-2 py-0.5 rounded-full border ${c.tag} font-medium`}>
                {prompt.tag}
              </span>
            )}
          </div>
          <CopyButton text={prompt.text} className="flex-shrink-0 mt-0.5" />
        </div>

        <pre className="text-sm text-slate-700 bg-slate-50 border border-slate-100 rounded-xl p-3.5 whitespace-pre-wrap font-sans leading-relaxed">
          {prompt.text}
        </pre>
      </div>
    </div>
  );
}
